import { APP_CONFIG } from '@debbie/cortex/dist/config.js';
export const APIBASE = `${APP_CONFIG.apiBase}/collection-engine`;
export const FILEBASE = `${APIBASE}/files`;
export const ENV = APP_CONFIG.environment;
export const IS_PROD = ENV === 'production';
export const CASEWORKER_URL = APP_CONFIG.caseworkerUrl;
export const DEFAULT_DEBTOR_WEB = APP_CONFIG.defaultDebtorWeb;
export const DEFAULT_CREDITOR_WEB = APP_CONFIG.defaultCreditorWeb;
//# sourceMappingURL=config.js.map